var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 15 13",
    fill: "#4C4C4C",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.23013 0.375C0.965091 0.375 0.75 0.600147 0.75 0.876333V11.1247C0.75 11.4009 0.965091 11.625 1.23013 11.625L12.7689 11.551C13.0344 11.551 13.25 11.3268 13.25 11.0507V0.876333C13.25 0.600137 13.0344 0.375 12.7689 0.375H1.23013ZM1.375 3.625H12.625V11H1.375V3.625ZM9.81218 2.93986C10.3314 2.93986 10.75 2.52091 10.75 2.00181C10.75 1.48273 10.3314 1.0625 9.81218 1.0625C9.29294 1.0625 8.875 1.48273 8.875 2.00181C8.875 2.52091 9.29294 2.93986 9.81218 2.93986ZM4.18718 1.0625C4.70544 1.0625 5.125 1.48273 5.125 2.00181C5.125 2.52091 4.70544 2.93986 4.18718 2.93986C3.66893 2.93986 3.25 2.52091 3.25 2.00181C3.25 1.48273 3.66893 1.0625 4.18718 1.0625ZM7.53554 9.18703H6.46445V7.84805H5.125V6.77648H6.46445V5.4375H7.53554V6.77648H8.875V7.84805H7.53554V9.18703Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Calendar.ac25011cf9637afeec93bb2143281760.svg";